import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ConfigProvider } from "@/hooks/useConfig";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Destinations from "@/pages/Destinations";
import Gallery from "@/pages/Gallery";
import PropertyPage from "@/pages/PropertyPage";
import Book from "@/pages/Book";
import BookingStatus from "@/pages/BookingStatus";
import ManageBooking from "@/pages/ManageBooking";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Policy from "@/pages/Policy";
import Admin from "@/pages/Admin";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import NotFound from "@/pages/NotFound";

const ClerkOutlet = () => (
  <ClerkAuthProvider>
    <Outlet />
  </ClerkAuthProvider>
);

function App() {
  return (
    <ConfigProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/destinations" element={<Destinations />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/hotels/:slug" element={<PropertyPage />} />
            <Route path="/book" element={<Book />} />
            <Route path="/booking/:id" element={<BookingStatus />} />
            <Route path="/manage-booking" element={<ManageBooking />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/policies/:policy" element={<Policy />} />
            <Route element={<ClerkOutlet />}>
              <Route path="/admin" element={<Admin />} />
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignUpPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </ConfigProvider>
  );
}

export default App;
